import React from 'react';
import { styled } from '@linaria/react';

import Demo, { DemoSliderControl } from '@/components/Demo';

import FinalParticleButton from './FinalParticleButton';

function TwinklingDemo() {
  return (
    <Demo
      initialValues={{
        twinkleIntensity: 0,
      }}
      outputWrapper={null}
      customGrid={{
        gridTemplateColumns: 'min(400px, 100%)',
        justifyContent: 'center',
      }}
      controls={[
        <DemoSliderControl
          highlightControlWhenActive
          key="twinkleIntensity"
          id="twinkleIntensity"
          label="Twinkle Intensity"
          min={0}
          max={1}
          step={0.01}
          previewRenderer={(value: string | number) => {
            return `${Math.round(Number(value) * 100)}%`;
          }}
        />,
      ]}
    >
      {({ twinkleIntensity }) => {
        return (
          <Wrapper>
            <FinalParticleButton
              chaos={0.5}
              twinkleIntensity={twinkleIntensity}
            />
          </Wrapper>
        );
      }}
    </Demo>
  );
}

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 1rem;
`;

export default TwinklingDemo;
